import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEditorH3 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 640 512",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M296 64C282.8 64 272 74.75 272 88V224h-224V88C48 74.75 37.25 64 24 64S0 74.75 0 88v336C0 437.3 10.75 448 24 448s24-10.75 24-24V272h224v152C272 437.3 282.8 448 296 448S320 437.3 320 424V88C320 74.75 309.3 64 296 64zM534.6 223.4h-34.13l115.5-118.9c6.719-6.906 8.641-17.19 4.891-26.06c-3.766-8.875-12.47-14.66-22.11-14.66L400 63.94c-13.25 0-24 10.59-24 23.84s10.75 24 24 24h141.1l-115.5 118.9c-6.719 6.906-8.641 17.19-4.891 26.06c3.766 8.875 12.47 14.66 22.11 14.66h90.91c31.66 0 57.41 28.78 57.41 64.19s-25.75 64.19-57.41 64.19h-77.11c-15.52 0-29.41-11.22-34.55-27.94c-3.906-12.66-17.23-19.81-30-15.88c-12.67 3.906-19.78 17.31-15.88 30c11.38 36.97 43.69 61.81 80.42 61.81h77.11C592.7 447.8 640 397.5 640 335.6S592.7 223.4 534.6 223.4z",
		fill: "currentColor"
	})
});
export default SvgEditorH3;
